import { useLocation, useNavigate } from "react-router-dom";
import { useGetEcoActivityDetails } from "../../../queries/facts";
import { ActionButton } from "../../../components/Forms/ActionButton";
import Chip from "../../../components/Chip";

const EcoActivityDetails = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const id = state?.id;

    const { data, isPending } = useGetEcoActivityDetails(id);
    console.log("EcoActivityDetails data:", data);

    if (isPending) {
        return <div>Loading...</div>;
    }

    return (
        <div className="p-5">
            <section className="flex flex-col pt-5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                    <h1 className="self-start text-2xl text-primary font-bold">View Eco Activity</h1>
                    <div className="mt-4">
                        <p className="my-2"><strong>Title:</strong> {data?.title}</p>
                        <p className="my-2"><strong>User Name:</strong> {data?.userName}</p>
                        <p className="my-2"><strong>Date:</strong> {new Date(data?.createdAt).toLocaleString()}</p>
                        <p className="my-2 inline-flex"><strong className="mr-2">Shown in Home Screen:</strong> <Chip value={data?.showInHomePage ? "Yes" : "No"} color={data?.showInHomePage ? "green" : "inactive"} /> </p>
                        <p className="my-2"><strong>Hashtags:</strong> {data?.hashTag.trim().split(" ").map(tag => (
                            <span key={tag} className="bg-gray-200 text-gray-700 px-1 py-1 rounded-full">
                                {tag.startsWith("#") ? tag : `#${tag}`}
                            </span>
                        ))}</p>
                        <p><strong>Activity Media</strong></p>
                        {data?.imageUrl && (
                            data?.imageUrl.split('.').pop().toLowerCase() === 'mp4' ? (
                                <video
                                    src={data?.imageUrl}
                                    controls
                                    className="w-96 h-auto mt-2 rounded-md shadow-sm"
                                />
                            ) : (
                                <img
                                    src={data?.imageUrl}
                                    alt="Activity"
                                    className="w-96 h-auto mt-2 rounded-md shadow-sm"
                                />
                            )
                        )}
                    </div>
                    <div className="flex justify-end mt-3 p-5">
                        <ActionButton
                            text={'Edit'}
                            variant={'submit'}
                            handleSubmit={() => navigate('/eco-activity/edit-eco-activity-details', { state: { id: data?._id } })}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default EcoActivityDetails;